import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import HeavySetDataContext from '../../context/HeavySetDataContext';
import UserSettingsContext from '../../context/UserSettingsContext';
import { groupBySingle, toArray, setExercise1RM, setExerciseTotalReps, setExerciseTotalVolume, setExercisePR, filterByExercise } from '../../data/helpers';
import { Row, Col } from '../../styles/Grid';
import Card from '../Dashboard/Card';
import styled from 'styled-components';
import Line from '../Charts/Line';

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: -2px;
  text-transform: uppercase;
`;

const SingleExercise = () => {
  const [showChart, setShowChart] = useState(false);
  const location = useLocation();
  const { state: { exercise }, } = location;
  const data = useContext(HeavySetDataContext);
  const { units } = useContext(UserSettingsContext);
  const groupExercisesByWorkout = toArray(groupBySingle(filterByExercise(data, exercise), 'workout'));
  const pr = setExercisePR(filterByExercise(data, exercise), exercise);
  const frequency = filterByExercise(data, exercise).length;

  const exerciseMaxWeight = groupExercisesByWorkout.map(d => {
    const name = d[0].workout;
    return {
      id: name,
      data: d.map(w => ({
        x: w.date,
        y: w.exercises[exercise].maxWeight[units],
      }))
    }
  });

  const exerciseTotalVolume = groupExercisesByWorkout.map(d => {
    const name = d[0].workout;
    return {
      id: name,
      data: d.map(w => ({
        x: w.date,
        y: w.exercises[exercise].volume[units],
      }))
    }
  });

  useEffect(() => {
    const isChart = exerciseMaxWeight.map(w => w.data.filter(w => w.y > 0)).every(w => w.length);
    setShowChart(isChart)
  }, [exerciseMaxWeight]);

  return (
    <>
      <Title>{exercise}</Title>

      <Row>
        <Col size={1}>
          <Card>
            <h3 className="Card__title">Personal Record</h3>
            <div className="Card__data">{pr[units]}{units} @ {pr.reps} reps</div>
            <h6 className="Card__subtitle">on {new Date(pr.date).toLocaleDateString()}</h6>
          </Card>
        </Col>
        <Col size={1}>
          <Card>
            <h3 className="Card__title">Estimated One Rep Max</h3>
            <div className="Card__data">{setExercise1RM(filterByExercise(data, exercise), exercise)[units]}{units}</div>
          </Card>
        </Col>
        <Col size={1}>
          <Card>
            <h3 className="Card__title">Frequency trained</h3>
            <div className="Card__data">{frequency}</div>
            <h6 className="Card__subtitle">Total reps: {setExerciseTotalReps(filterByExercise(data, exercise), exercise)}</h6>
          </Card>
        </Col>
        <Col size={1}>
          <Card>
            <h3 className="Card__title">Total Volume lifted</h3>
            <div className="Card__data">{setExerciseTotalVolume(filterByExercise(data, exercise), exercise)[units]}{units}</div>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col size={1}>
          <Card>
            <div style={{ height: showChart ? 500 : 'auto' }}>
              <h3 className="Card__title">Max weight lifted</h3>
              {
                showChart ? <Line
                  data={exerciseMaxWeight}
                  axisBottomLegend="Date"
                  axisLeftLegend="Weight"
                  tooltipY={units}
                /> : `No max-weight data for this exercise.`
              }
            </div>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col size={1}>
          <Card>
            <div style={{ height: showChart ? 460 : 'auto' }}>
              <h3 className="Card__title">Total volume lifted</h3>
              {
                showChart ? <Line
                  data={exerciseTotalVolume}
                  axisBottomLegend="Date"
                  axisLeftLegend="Total Volume"
                  tooltipY={units}
                /> : `No total volume data for this exercise.`
              }
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default SingleExercise;
